var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "onboarding-quicktrial-layout",
    {
      attrs: { isDesktop: _vm.isDesktop },
      scopedSlots: _vm._u([
        {
          key: "banner",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "onboarding-quicktrial__banner" },
                [
                  _c(
                    "div",
                    { staticClass: "onboarding-quicktrial__banner-header" },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "onboarding-quicktrial__banner-header-title"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t.__("common.labels.15_days_free_trial")
                              ) +
                              " 🚀\n                "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "onboarding-quicktrial__banner-baseline" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__("common.labels.without_commitment")
                          ) +
                          " -\n                " +
                          _vm._s(
                            _vm.$t.__("common.labels.no_credit_card_required")
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "onboarding-quicktrial__banner-details",
                    domProps: { innerHTML: _vm._s(_vm.translations.details) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "onboarding-quicktrial__banner-illustration-container"
                    },
                    [
                      _c("img", {
                        staticClass:
                          "onboarding-quicktrial__banner-illustration",
                        attrs: {
                          src: _vm.banner,
                          alt: _vm.$t.__(
                            "common.labels.freely_test_all_features_alt"
                          )
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "onboarding-quicktrial__banner-subtitle",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t.__("common.labels.companies_trust_sellsy", {
                          br: "<br />"
                        })
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("customer-logo", {
                    staticClass: "onboarding-quicktrial__banner-customer-logo"
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [_vm._v(" "), _c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }